import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SkeletonPattern from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';
import TeamMatchupImage from '@mlb/react-patterns/components/TeamMatchupImage/teamMatchupImage';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

import { useDictionary } from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';

const ratioWidth = 167;
const ratioHeight = 215;
const ratio = `${ratioWidth}:${ratioHeight}`;
const srcsetWidth = {
    '372w': 372,
    '640w': 640,
    '750w': 750,
    '1024w': 1024,
    '1536w': 1536,
    '1920w': 1920,
    '2208w': 2208,
};

const Skeleton = styled(SkeletonPattern)`
    padding-bottom: ${(ratioHeight/ratioWidth) * 100}%;
    position: relative;
`;

const Container = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
    line-height: 0;
`;

const Title = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 20%;
    background-image: linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,0.75));
    padding: 0 8%;
    font-family: ${({ theme }) => theme.fonts?.family?.primary};
    font-weight: bold;
    font-size: clamp(1.125rem, 0.8565rem + 1.3423vw, 1.5rem);
    color: ${({ theme }) => theme.primaryTextColor};
    text-shadow: 2px 2px 4px ${COLORS.mlbBlack};

    ${media.mdmin`
        font-size: 18px;
    `}
`;

const Story = (props) => {

    const {
        data,
        loading,
    } = props;

    const { game_story = 'Game Story', not_available = 'Not Available' } = useDictionary();
    const [
        imgLoaded,
        setImgLoaded,
    ] = useState(false);
    const handlers = useMemo(() => ({
        onLoad: () => setImgLoaded(true),
        onError: () => setImgLoaded(true),
    }), [setImgLoaded]);
    const storyUrl = (data.storyUrl || '').replace('/en', '');

    return (
        <Skeleton
            width={'100%'}
            height={'0'}
            margin={'0'}
            isLoading={!imgLoaded}
        >
            {!loading && (
                <Container
                    {...storyUrl && {
                        as: 'a',
                        href: `https://${storyUrl}`,
                        target: '_blank',
                        onClick: Tracking.trackGameIndexPageGameStoryClick,
                    }}
                >
                    <TeamMatchupImage
                        handlers={handlers}
                        awayTeamId={data.away?.id}
                        homeTeamId={data.home?.id}
                        ratio={ratio}
                        srcWidth={750}
                        srcsetWidth={srcsetWidth}
                    />
                    <Title>{storyUrl ? game_story : not_available}</Title>
                </Container>

            )}
        </Skeleton>
    );

};

Story.propTypes = {
    loading: PropTypes.bool.isRequired,
    data: PropTypes.object,
};

Story.defaultProps = {
    data: {},
};

export default Story;
